import React from 'react';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from 'components/mui';
import { Skeleton, Typography } from '@mui/material';
import { CANtrackComment } from '../../types/comment';
import CommentsTableRow from './CommentsTableRow';

interface CommentsTableProps {
	// Define the props for your component here
	comments: CANtrackComment[];
	loadingComments: boolean;
	showDecimalFormat: boolean;
	setComments: React.Dispatch<React.SetStateAction<CANtrackComment[]>>;
	onCopyCommentClick: (commentToCopy: CANtrackComment) => void;
}

const LoadingRows: React.FC<{ count: number }> = ({ count }) => (
	<>
		{[...Array(count)].map((_, index) => (
			<TableRow key={index}>
				<TableCell colSpan={7} align="center">
					<Typography variant="h5" align="center">
						<Skeleton variant="rounded" animation="wave" />
					</Typography>
				</TableCell>
			</TableRow>
		))}
	</>
);

const NoEntries: React.FC = () => (
	<TableRow>
		<TableCell colSpan={6}>
			<Typography
				variant="h5"
				align="center"
				fontWeight={300}
				color={'warning.main'}
			>
				No entries found
			</Typography>
		</TableCell>
	</TableRow>
);

const CommentsTable: React.FC<CommentsTableProps> = (props) => {
	const {
		comments,
		loadingComments,
		showDecimalFormat,
		setComments,
		onCopyCommentClick,
	} = props;
	const commentsSorted = comments.sort(
		(a, b) => a.date.getTime() - b.date.getTime(),
	);

	return (
		<div>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 650 }} size="small">
					<TableHead>
						<TableRow>
							<TableCell />
							<TableCell>Client</TableCell>
							<TableCell align="left">Case</TableCell>
							<TableCell align="left">Summary</TableCell>
							<TableCell align="left">Entry&nbsp;Time</TableCell>
							<TableCell align="left">Time&nbsp;Spent</TableCell>
							<TableCell />
						</TableRow>
					</TableHead>
					<TableBody>
						{loadingComments ? (
							<LoadingRows
								count={
									comments.length > 0 ? comments.length : 5
								}
							/>
						) : (
							<>
								{commentsSorted.length === 0 && <NoEntries />}
								{commentsSorted.map((entry) => (
									<CommentsTableRow
										key={entry.id}
										comment={entry}
										setComments={setComments}
										decimalFormat={showDecimalFormat}
										onCopyCommentClick={onCopyCommentClick}
									/>
								))}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default CommentsTable;
